import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { Icon } from '@/src/tools/icon';
import {
  // 移动手柄
  MenuOutlined,
} from '@ant-design/icons';
import { get, set } from 'lodash';
import React from 'react';
import {
  Form,
  Input,
  OriCheckbox,
  OriNumberInput,
  OriSelect,
} from 'src/components/Antd';
import DragNDrop from 'src/components/DragNDrop';
import Section from 'src/pages/SalesCannelVersion/Components/SectionContainer';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { DiscountValueType } from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/AtDiscountValue';
import { isInteger } from 'src/tools/helper';
import RecurrenceRange, {
  Recurrence,
} from '../../../Components/RecurrenceRange';
import Card from '../Card';
import css from './css.module.less';
import {
  SubscriptionBuyType,
  ESubscriptionBuyType,
} from 'src/types/common/discount';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const List = Form.List;
const Item = Form.Item;
const Option = OriSelect.Option;
const _base = 'frequencies';

const _ItemWrapper = (props) => {
  const { children, ...rest } = props;
  return (
    <ItemWrapper containerClassName={css.itemWrapper} {...rest}>
      {children}
    </ItemWrapper>
  );
};

const Frequency = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { form, isPrimary, currency, disableEdit } = props;
  return (
    <SectionWrapper
      id='salesChannelSubscriptionBuyFrequency'
      title={getI18n(
        'salesChannelSubscriptionBuy.frequency.subscriptionBuyFrequency',
      )}
      containerClassName={css.section}>
      <List
        name={_base}
        rules={[
          {
            validator: async (_, names) => {
              // console.log('names', names);
              if ((names || []).length < 1) {
                return Promise.reject(
                  new Error(
                    getI18n(
                      'salesChannelSubscriptionBuy.frequency.1condiction',
                    ),
                  ),
                );
              }
              // const recommended = (names || []).filter((i) => {
              //   return i.recommended;
              // });
              // // console.log('recommended', recommended);
              // if ((recommended || []).length < 1) {
              //   return Promise.reject(
              //     new Error('Please select at least one recommended'),
              //   );
              // }
            },
          },
        ]}>
        {(fields, { add, remove, move }, { errors }) => {
          const handleOnRemove = (index) => {
            remove(index);
          };
          const _fields = fields.map((i) => {
            return { ...i, draggableId: i.fieldKey.toString() };
          });
          return (
            <React.Fragment>
              <DragNDrop
                disableAllDrags={!isPrimary || disableEdit}
                list={_fields}
                droppableId={'Test'}
                childGenerator={(item, provided, index) => {
                  return (
                    <_Card
                      fields={fields}
                      dragProps={provided.dragHandleProps}
                      index={index}
                      listName={_base}
                      onDelete={handleOnRemove}
                      form={form}
                      isPrimary={isPrimary}
                      currency={currency}
                      disableEdit={!isPrimary || disableEdit}
                    />
                  );
                }}
                onChange={(oldIndex: number, newIndex: number) => {
                  move(oldIndex, newIndex);
                }}
              />
              {isPrimary && !disableEdit && (
                <div
                  className={css.addContainer}
                  onClick={() => {
                    add({
                      frequency: 1,
                      frequencyUnit: EFrequencyUnit.Days,
                      orderCount: 0,
                      recurrence: Recurrence.EndAfter,
                      subscriptionType: ESubscriptionBuyType.PayUpfront,
                      discount: {
                        type: DiscountValueType.Percentage,
                      },
                    });
                  }}>
                  +{' '}
                  {getI18n(
                    'salesChannelSubscriptionBuy.frequency.addSubscriptionBuyFrequency',
                  )}
                </div>
              )}

              {(errors || []).length > 0 && (
                <div className={css.errorContainer}>
                  <Form.ErrorList errors={errors} />
                </div>
              )}
            </React.Fragment>
          );
        }}
      </List>
      <Item
        className={css.recommendedValidating}
        name={['testList']}
        rules={[
          {
            validator: async (_, names) => {
              // // console.log('names', names);
              // // if ((names || []).length < 1) {
              // //   return Promise.reject(
              // //     new Error('Please add at least 1 Condition'),
              // //   );
              // // }consol
              //console.log('validating');
              const data = form.getFieldValue(_base);
              const recommended = data.filter((i) => {
                return i.recommended;
              });
              // console.log('recommended', recommended);
              if ((recommended || []).length < 1) {
                return Promise.reject(
                  new Error(
                    getI18n('salesChannelSubscriptionBuy.frequency.1recommand'),
                  ),
                );
              }
            },
          },
        ]}>
        <div />
      </Item>
    </SectionWrapper>
  );
};
export default Frequency;

export enum EFrequencyUnit {
  Days = 'Days',
  Weeks = 'Weeks',
  Months = 'Months',
}

const _Card = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    dragProps,
    index,
    fields,
    currency,
    listName,
    onDelete,
    form,
    isPrimary,
    disableEdit,
  } = props;
  const getNamePrefix = [listName, index];
  const itemNamePrefix = fields[index]['name'];
  const directCheckName = [itemNamePrefix, 'discount', 'enableDirectDiscount'];
  const radioName = [itemNamePrefix, 'discount', 'type'];
  const percentageName = [itemNamePrefix, 'discount', 'percent'];
  const reductionAmountName = [itemNamePrefix, 'discount', 'fixAmount'];
  const enableProductName = [itemNamePrefix, 'discount', 'enableGifts'];
  const productTableName = [itemNamePrefix, 'discount', 'gifts'];
  const recurrenceName = [itemNamePrefix, 'orderCount'];
  const recurrenceRadioName = [itemNamePrefix, 'recurrence'];
  const getRecurrenceRadioName = [...getNamePrefix, 'recurrence'];
  const getDirectCheckName = [
    ...getNamePrefix,
    'discount',
    'enableDirectDiscount',
  ];
  const getRadioName = [...getNamePrefix, 'discount', 'type'];
  const getEnableProductName = [listName, index, 'discount', 'enableGifts'];
  const everyName = [itemNamePrefix, 'frequency'];
  const typeName = [itemNamePrefix, 'subscriptionType'];
  const getTypeName = [...getNamePrefix, 'subscriptionType'];

  const frequencyUnit = [itemNamePrefix, 'frequencyUnit'];
  const customerReminder = [itemNamePrefix, 'customerReminder'];
  const recommended = [itemNamePrefix, 'recommended'];
  //const getRecommended = [...getNamePrefix, 'recommended'];

  return (
    <Section bottomBorder className={css.cardContainer}>
      <div className={css.dragCol}>
        <div className={css.dragContainer} {...dragProps}>
          <MenuOutlined
            className={isPrimary && !disableEdit ? css.drag : css.dragDisabled}
          />
        </div>
      </div>
      <div className={css.contentContainer}>
        <div className={css.headerRow}>
          <div className={css.headerEvery}>
            <_ItemWrapper
              title={getI18n(
                'salesChannelSubscriptionBuy.frequency.subscriptionType',
              )}>
              <Item
                name={typeName}
                rules={[
                  {
                    requiredL: true,
                    message: getI18n('general.pleaseselectavalue'),
                  },
                ]}>
                <OriSelect
                  size='large'
                  placeholder={getI18n('general.type')}
                  onChange={(e) => {
                    if (e === ESubscriptionBuyType.PayUpfront) {
                      const obj = form.getFieldValue(_base);
                      set(obj, `${index}.recurrence`, Recurrence.EndAfter);
                      //obj[index].recurrence = Recurrence.EndAfter;

                      form.setFieldsValue({
                        _base: obj,
                      });
                    }
                  }}
                  disabled={!isPrimary || disableEdit}>
                  <Option value={ESubscriptionBuyType.PayUpfront}>
                    {SubscriptionBuyType[ESubscriptionBuyType.PayUpfront]}
                  </Option>
                  <Option value={ESubscriptionBuyType.RecurringPayment}>
                    {SubscriptionBuyType[ESubscriptionBuyType.RecurringPayment]}
                  </Option>
                </OriSelect>
              </Item>
            </_ItemWrapper>
          </div>
          <div className={css.headerEvery}>
            <_ItemWrapper title={`${getI18n('general.every')}*`}>
              <Item
                name={everyName}
                rules={[
                  {
                    validator: async (x, value) => {
                      if (!isInteger(value)) {
                        return Promise.reject(
                          new Error(getI18n('general.pleasefillavalidvalue')),
                        );
                      }
                      if (value < 1) {
                        return Promise.reject(
                          new Error(`${getI18n('general.noLessThan')} 1`),
                        );
                      }
                    },
                  },
                ]}>
                <OriNumberInput
                  max={10000}
                  size='large'
                  placeholder={getI18n('general.every')}
                  disabled={!isPrimary || disableEdit}
                />
              </Item>
            </_ItemWrapper>
          </div>
          <div className={css.headerFre}>
            <_ItemWrapper title={getI18n('general.frequency')}>
              <Item
                name={frequencyUnit}
                rules={[
                  {
                    requiredL: true,
                    message: getI18n('general.pleaseselectavalue'),
                  },
                ]}>
                <OriSelect
                  size='large'
                  placeholder={getI18n('general.frequency')}
                  disabled={!isPrimary || disableEdit}>
                  <Option value={EFrequencyUnit.Days}>
                    {getI18n('general.day(s)')}
                  </Option>
                  <Option value={EFrequencyUnit.Weeks}>
                    {getI18n('general.week(s)')}
                  </Option>
                  <Option value={EFrequencyUnit.Months}>
                    {getI18n('general.month(s)')}
                  </Option>
                </OriSelect>
              </Item>
            </_ItemWrapper>
          </div>

          <div className={css.headerRarePart}>
            <div className={css.checkbox}>
              <Item
                noStyle
                shouldUpdate={(p, c) => {
                  const pV = get(p, listName);
                  const pR = pV.findIndex((i) => i.recommended);
                  const cV = get(c, listName);
                  const cR = cV.findIndex((i) => i.recommended);
                  // console.log(pR, cR);
                  return pR !== cR;
                }}>
                {({ getFieldValue }) => {
                  const list = getFieldValue(listName) || [];
                  const isCheckedIndex = list.findIndex((i) => i.recommended);
                  //console.log('Changes');
                  setTimeout(() => {
                    form.validateFields(['testList']);
                  });
                  const shouldDisabled =
                    isCheckedIndex === -1
                      ? false
                      : isCheckedIndex === index
                      ? false
                      : true;
                  return (
                    <Item
                      name={recommended}
                      valuePropName={'checked'}
                      // rules={[
                      //   {
                      //     validator: async (_, names) => {
                      //       // console.log('names', names);
                      //       if (isCheckedIndex === -1) {
                      //         return Promise.reject(new Error('nono'));
                      //       }
                      //     },
                      //   },
                      // ]}
                    >
                      <OriCheckbox
                        disabled={shouldDisabled || !isPrimary || disableEdit}>
                        {getI18n('general.setasrecommended')}
                      </OriCheckbox>
                    </Item>
                  );
                }}
              </Item>
            </div>
            <Item
              noStyle
              shouldUpdate={(p, c) => {
                const pV = get(p, listName);
                const cV = get(c, listName);
                return cV !== pV;
              }}>
              {({ getFieldValue }) => {
                const list = getFieldValue(listName) || [];
                const shouldDisplay = list.length > 1 && isPrimary;
                if (shouldDisplay && !disableEdit) {
                  return (
                    <Icon
                      type='icondelete1'
                      className={css.deleteIcon}
                      onClick={() => {
                        onDelete(index);
                      }}
                    />
                  );
                }
                return null;
              }}
            </Item>
          </div>
        </div>
        <div className={css.headerReminder}>
          <_ItemWrapper
            title={`${getI18n(
              'salesChannelSubscriptionBuy.frequency.customerReminder',
            )}*`}>
            <Input
              size='large'
              placeholder={`${getI18n(
                'salesChannelSubscriptionBuy.frequency.customerReminder',
              )}`}
              maxLength={50}
              formProps={{
                name: customerReminder,
                rules: [{ required: true, message: 'Please fill reminder' }],
              }}
            />
          </_ItemWrapper>
        </div>
        <div className={css.container}>
          <Item>
            <OriCheckbox className={css.directDiscount} disabled checked>
              {getI18n(
                'salesChannelSubscriptionBuy.frequency.rangeofrecurrence',
              )}
              *​
            </OriCheckbox>
            <div className={css.directContainer}>
              <Item
                shouldUpdate={(p, c) => {
                  //subscriptionType
                  const cV = get(c, getTypeName);

                  const pV = get(p, getTypeName);
                  return cV !== pV;
                }}>
                {(f) => {
                  const { getFieldValue } = f;
                  const type = get(
                    getFieldValue(`${listName}`),
                    `${index}.subscriptionType`,
                  );
                  // console.log(type);
                  const isUpFront = type === ESubscriptionBuyType.PayUpfront;
                  // if (isUpFront) {
                  //   form.setFieldValue(
                  //     `${getRecurrenceRadioName}`,
                  //     Recurrence.NoEndDate,
                  //   );
                  //   // setFieldsValue({
                  //   //   recurrenceRadioName: Recurrence.EndAfter,
                  //   // });
                  // }
                  return (
                    <RecurrenceRange
                      recurrenceName={recurrenceName}
                      recurrenceRadioName={recurrenceRadioName}
                      getRecurrenceRadioName={getRecurrenceRadioName}
                      disableEdit={disableEdit}
                      isUpFront={isUpFront}
                      //listName={listName}
                    />
                  );
                }}
              </Item>
            </div>
          </Item>
        </div>
        <Item
          shouldUpdate={(p, c) => {
            const pV = get(p, 'applyToDifferentDiscount');
            const cV = get(c, 'applyToDifferentDiscount');
            return pV !== cV;
          }}>
          {({ getFieldValue }) => {
            const shouldDisplay =
              getFieldValue('applyToDifferentDiscount') && isPrimary;

            if (shouldDisplay) {
              return (
                <Card
                  tableId={`SalesChannelSubscriptionTable${index}`}
                  currency={currency || 'HKD'}
                  percentageName={percentageName}
                  directCheckName={directCheckName}
                  radioName={radioName}
                  reductionAmountName={reductionAmountName}
                  enableProductName={enableProductName}
                  productTableName={productTableName}
                  getDirectCheckName={getDirectCheckName}
                  getEnableProductName={getEnableProductName}
                  getRadioName={getRadioName}
                  disableEdit={disableEdit}
                />
              );
            }
            return null;
          }}
        </Item>
      </div>
    </Section>
  );
};
